import { render, staticRenderFns } from "./ViewAppLink.vue?vue&type=template&id=2367afa4&"
import script from "./ViewAppLink.vue?vue&type=script&lang=js&"
export * from "./ViewAppLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports